import {
  TAGS_TREND_LABELS,
  TAGS_TREND_VALUES,
  type TagsTrend,
} from "@playbookai/widget-schemas";
import type { StatusTone } from "../../atoms/StatusDot/index.js";

/** Select options in stored order; labels come from the shared contract. */
export const TAGS_TREND_OPTIONS: ReadonlyArray<{
  readonly value: TagsTrend;
  readonly label: string;
}> = TAGS_TREND_VALUES.map((value) => ({
  value,
  label: TAGS_TREND_LABELS[value],
}));

export function tagsTrendLabel(trend: TagsTrend): string {
  return TAGS_TREND_LABELS[trend];
}

/**
 * Semantic tone per classification. `unknown` stays neutral (it is the honest
 * "not established" state, not a warning), a `stable` problem is held under
 * watch, and improving/worsening map to healthy/critical.
 */
const TAGS_TREND_TONE: Record<TagsTrend, StatusTone> = {
  unknown: "neutral",
  improving: "healthy",
  stable: "watch",
  worsening: "critical",
};

export function tagsTrendTone(trend: TagsTrend): StatusTone {
  return TAGS_TREND_TONE[trend];
}
